module.exports = __webpack_public_path__ + "img/banner.f22f6658.jpg";